import { useEffect, useState } from "react"

export const useCommentsData = (postId?: number, withComments = false) => {
  const [count, setCommentsCount] = useState(0)
  const [comments, useComments] = useState([])
  useEffect(() => {
    if (postId) {
      const fetchData = async () => {
        try {
          const response = await fetch(
            `/.netlify/functions/get-community-comments/${postId}`,
            {
              method: "post",
              body: JSON.stringify({
                comments: withComments,
              }),
            }
          )
          const json = await response.json()
          if (response.ok) {
            const parsedResponse = JSON.parse(json.message)
            useComments(parsedResponse.comments)
            setCommentsCount(parsedResponse.comments_count)
          } else {
            setCommentsCount(0)
          }
        } catch (error) {
          console.log(error)
          return setCommentsCount(0)
        }
      }
      if (!count) {
        fetchData()
      }
    } else {
      setCommentsCount(0)
    }
  }, [])
  return {
    count,
    comments,
  }
}
